/* eslint-disable no-constant-condition */
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'contexts/Localization'
import useToast from 'hooks/useToast'
import { setAddToCart } from 'state/cart/actions'

export const useAddToCart = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { toastSuccess }: any = useToast()

  const { cartNFT } = useSelector((state: any) => state.cart)
  const { isLogin } = useSelector((state: any) => state.auth)

  const addToCart = useCallback(
    (product) => {
      if (isLogin) {
        if (!cartNFT?.find((item) => item?.nft?.id === product?.nft?.id)) {
          dispatch(setAddToCart([...cartNFT, product]))
          localStorage.setItem('cart', JSON.stringify([...cartNFT, product]))
          toastSuccess('Add to cart success')
        } else {
          dispatch(setAddToCart(cartNFT?.filter((item) => item?.nft?.id !== product?.nft?.id)))
          localStorage.setItem('cart', JSON.stringify(cartNFT?.filter((item) => item?.nft?.id !== product?.nft?.id)))
          toastSuccess('Remove to cart success')
        }
      }
    },
    [cartNFT, dispatch, isLogin, toastSuccess],
  )

  return [addToCart]
}

export const useLoadCart = () => {
  const dispatch = useDispatch()
  const { isLogin } = useSelector((state: any) => state.auth)

  const getLoadCart = useCallback(() => {
    if (isLogin) {
      const dataCart = localStorage.getItem('cart')
      if (dataCart) {
        const jsonDataCart = JSON.parse(dataCart)
        dispatch(setAddToCart(jsonDataCart))
      }
    }
  }, [dispatch, isLogin])

  useEffect(() => {
    getLoadCart()
  }, [getLoadCart])

  return [getLoadCart]
}

export const useRemoveAddToCart = () => {
  const dispatch = useDispatch()
  const { toastSuccess }: any = useToast()

  const { cartNFT } = useSelector((state: any) => state.cart)
  const { isLogin } = useSelector((state: any) => state.auth)

  const removeAddToCart = useCallback(
    (product) => {
      if (isLogin) {
        if (product?.length > 1) {
          const filteredArray1 = cartNFT.filter((obj1) => !product.some((obj2) => obj1.nft.id === obj2.nft.id))
          dispatch(setAddToCart(filteredArray1))
          localStorage.setItem('cart', JSON.stringify(filteredArray1))
        } else {
        
          dispatch(setAddToCart(cartNFT?.filter((item) => item.nft.id !== product.nft.id)))
          localStorage.setItem('cart', JSON.stringify(cartNFT?.filter((item) => item.nft.id !== product.nft.id)))
        }

        toastSuccess('Remove to cart success')
      }
    },
    [cartNFT, dispatch, isLogin, toastSuccess],
  )

  return [removeAddToCart]
}
